import ServerProxy from '../../proxy/ServerProxy';
import Encryption from "@/common/encryption";
const initialStore = function(){
    return {
        // eslint-disable-next-line no-undef
        config:config,
        authToken: null,
        refreshToken: null,
        serverProxy: new ServerProxy(),
        errorMessage: {},
        userId:null
    }
}

const ConfigStore = {
    state: initialStore,
    getters: {
        getConfig(state){
            return state.config;
        },
        getAuthToken(state) {
            return state.authToken;
        },
        getRefreshToken(state) {
            return state.refreshToken;
        },
        getErrorMessage(state) {
            return state.errorMessage;
        },
        getUserId(state) {
            return state.userId;
        }
    },
    actions:{
        setErrorMessage({ commit }, msg) {
            commit("setErrorMessage", msg);
        },
        setAuthToken({ commit, state }, data) {
            return new Promise((resolve, reject) => {
                state.serverProxy.serverRequest({
                    url: `${state.config.auth_service_url}/getAccessTokeByAuthCode?client_id=${data.client_id}&code=${data.code}&redirect_uri=${state.config.redirect_uri}`,
                    method: `GET`,
                    headers: { 'Content-Type': `application/json` },

                })
                    .then(response => {
                        resolve(response);
                        console.log("setAuthToken", response);
                        commit("setAuthToken", response);
                    })
                    .catch(err =>
                        reject(err)
                    );
            });
        },
        resetState({ commit }) {
            commit('resetState');
        },
        logout({ commit }) {
            commit("logout");
            /*return new Promise((resolve, reject) => {
                state.serverProxy.logout(state.authToken, state.refreshToken, state.config)
                    .then(response => {
                        resolve(response);
                       
                    })
                    .catch(err => {
                        reject(err);
                    });
            });*/
        }, 
        initializeUserAuthState({ commit }) {
            commit("initializeUserAuthState");
        },
        introspectToken({ commit,state }) {
            return new Promise((resolve, reject) => {
                state.serverProxy.serverRequest({
                    url: `${state.config.auth_service_url}/introspectToken?client_id=${state.config.client_id}&access_token=${state.authToken}`,
                    method: `POST`,
                    headers: { 'Content-Type': `application/json` },

                })
                    .then(response => {
                        resolve(response);
                        console.log("instrospectToken", response);
                        commit("setUserId", response.user_id);
                    })
                    .catch(err =>
                        reject(err)
                    );
            });
        },
        setAuthTokenFromAPI({ commit }, data) {
            commit("setAuthTokenFromAPI", data);
        } 

    },
    mutations: {
        initializeUserAuthState(state) {
            const encryption = new Encryption("rsi-services");
            if (sessionStorage.getItem('rsi-user')) {
                state.authToken = encryption.readDataWithDecrypt(state.config['rsi_user']);
            }
            if (sessionStorage.getItem('rsi-token')) {
                state.refreshToken = encryption.readDataWithDecrypt(state.config['rsi_token']);
            }
        },
        resetState(state) {
            const values = initialStore();
            Object.assign(state, values);
        },
        setErrorMessage(state, msg) {
            state.errorMessage = msg;
        },
        setAuthToken(state, data) {
            state.authToken = data.access_token;
            state.refreshToken = data.refresh_token;
        }, 
        logout(state) {
            state.authToken = null;
            sessionStorage.clear();
        },
        setUserId(state,userId){
            state.userId = userId;
        },
        setAuthTokenFromAPI(state, data) {
            state.authToken = data.access_token;
        },
    }

}

export default ConfigStore;